export default "__VITE_ASSET__XpxDRH2s__"